import axios from 'axios';
import { getProject } from './gcloud/getProject';

export default function copyWorkflowFiles(body, projectUrl = getProject(), httpRequest = axios) {
  const config = {
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json'
  };

  return httpRequest({
    url: `${projectUrl}/copyFormFilesV2`,
    method: 'POST',
    headers: config,
    data: JSON.stringify(body)
  })  
}